import React from 'react';
import { Loading, Tabs } from 'components';

const MposUsers = React.lazy(() => import('./Users'));
const MposTransactions = React.lazy(() => import('./Transactions'));
const MposTips = React.lazy(() => import('./Tips'));
const MposSettings = React.lazy(() => import('./Settings'));

const Mpos = () => {
    const [tab, setTab] = React.useState('TRANSACTIONS');

    const tabItems = [
        {
            key: 'TRANSACTIONS',
            label: 'Transactions',
            children: (
                <React.Suspense fallback={<Loading spinning={true} />}>
                    <MposTransactions />
                </React.Suspense>
            ),
        },
        {
            key: 'TIPS',
            label: 'Tips',
            children: (
                <React.Suspense fallback={<Loading spinning={true} />}>
                    <MposTips />
                </React.Suspense>
            ),
        },
        {
            key: 'USERS',
            label: 'Users',
            children: (
                <React.Suspense fallback={<Loading spinning={true} />}>
                    <MposUsers />
                </React.Suspense>
            ),
        },
        {
            key: 'SETTINGS',
            label: 'Settings',
            children: (
                <React.Suspense fallback={<Loading spinning={true} />}>
                    <MposSettings />
                </React.Suspense>
            ),
        },
    ];

    return (
        <React.Fragment>
            <div className="rounded-xl pt-2s">
                <Tabs type="card" value={tab} items={tabItems} onChange={e => setTab(e)} />
            </div>
        </React.Fragment>
    );
};

export default Mpos;
